import React from 'react';
import PropTypes from 'prop-types';

export default class Select extends React.Component {

    componentDidMount() {
        global.$.AdminBSB.select.activate();
    }

    render() {
        const className = this.props.className;

        return (
            <select className={className}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
            >
                <option key={-1} value={-1}></option>
                {this.props.options.map((object, i) =>
                    <option key={i}
                            value={object.value}>
                        {object.name}
                    </option>,
                )}
            </select>
        );
    }

}

Select.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    value: PropTypes.number,
    disabled: PropTypes.bool,
};

Select.defaultProps = {
    className: '',
    onChange: (event) => {},
    options: [],
    value: -1,
    disabled: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Select.js